module.exports = __webpack_public_path__ + "dff83ce4787b7539fe9ad5a5a67244d8.svg";